import { useMemo } from 'react'
import { useAuthStatus } from '@/features/user'
import { useSSEConnectionContext } from '@/infra/sse'
import { env } from '@/infra/config/env'

export interface SystemInfo {
  readonly userId: string | null
  readonly backendUrl: string
  readonly conversationStreamId: string | null
  readonly activityStreamId: string | null
}

export function useSystemInfo(): SystemInfo {
  const { user } = useAuthStatus()
  const sseContext = useSSEConnectionContext()

  return useMemo(
    () => ({
      userId: user?.profile?.sub ?? null,
      backendUrl: env.BACKEND_BASE_URL,
      conversationStreamId: sseContext.conversationConnectionId,
      activityStreamId: sseContext.activityConnectionId,
    }),
    [user?.profile?.sub, sseContext.conversationConnectionId, sseContext.activityConnectionId],
  )
}
